<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    v-if="dialog"
  >
    <popup-header @clickClose="closeModal()" :headerBg="'grey'" />

    <v-container class="bg-grey app-wrapper fixed-btn-padding">
      <!-- 제목 -->
      <v-row class="title-wrap app">
        <v-col
          cols="12"
          class="icon-title word-type d-flex justify-space-between"
        >
          <span>
            <!-- 신청서에 따라 아이콘 변경 -->
            <appl-menu-icon
              :propsParam="{
                applCd: appInfoParam.applCd,
                gntGubunCd: appInfoParam.gntGubunCd,
              }"
              :styleClassStr="'mr-0'"
            ></appl-menu-icon>
            {{ /*appInfoParam.applNm==='휴직증명서'?appInfoParam.applNm:appInfoParam.applNm+'서'*/
              appInfoParam.title
            }}</span
          >
          <!-- 재사용 버튼 (개발예정) -->
          <!-- <v-btn elevation="0" color="#e1e3e5" height="38" class="btn-reuse"
            ><v-icon size="16" class="mr-1">mdi-clipboard-text-outline</v-icon
            >재사용</v-btn
          > -->
        </v-col>
      </v-row>
      <!-- 내용 -->
      <v-row class="mt-0 overflow-y-auto">
        <v-col cols="12" class="pt-3 px-6 pb-10">
          <!-- 신청서 시작 -->
          <v-card
            class="mx-auto card-box"
            elevation="0"
            v-show="!GET_APP_LOADING_STATUS"
          >
            <!-- 신청서 내용 (스피너 OFF시 노출) -->
            <v-list class="card-contents">
              <!-- 근태,보상,근태취소,보상취소 
              <vacation-viewer-data
                v-if="
                  appInfoParam.applCd === '42' ||
                  appInfoParam.applCd === '43'
                "
                :appInfoParam="appInfoParam"
                @showCancelApplBtn="showCancelApplBtn"
                @hideCancelApplBtn="hideCancelApplBtn"
              />
              -->
              <!-- 독감예방접종 -->
              <vaccination-viewer-data
                v-if="appInfoParam.applCd === '7051'"
                :appInfoParam="appInfoParam"
                @showCancelApplBtn="showCancelApplBtn"
                @hideCancelApplBtn="hideCancelApplBtn"
                @showFileView="showFileView"
              />
              <!-- 학자금 -->
              <edus-app-viewer-data
                v-if="appInfoParam.applCd === '7021'"
                :appInfoParam="appInfoParam"
                @showCancelApplBtn="showCancelApplBtn"
                @hideCancelApplBtn="hideCancelApplBtn"
                @showFileView="showFileView"
              />
              <!-- 휴/복직(육아휴직, 가족돌봄휴직) -->
              <lea-abs-par-fam-viewer-data
                v-if="
                  appInfoParam.applCd === '151' || appInfoParam.applCd === '153'
                "
                :appInfoParam="appInfoParam"
                @showCancelApplBtn="showCancelApplBtn"
                @hideCancelApplBtn="hideCancelApplBtn"
                @showFileView="showFileView"
              />
              <!-- 휴/복직(난임치료휴직, 공상휴직, 사상휴직, 신상휴직) -->
              <lea-abs-etc-viewer-data
                v-if="
                  appInfoParam.applCd === '154' ||
                  appInfoParam.applCd === '157' ||
                  appInfoParam.applCd === '158' ||
                  appInfoParam.applCd === '159' ||
                  appInfoParam.applCd === '156'
                "
                :appInfoParam="appInfoParam"
                @showCancelApplBtn="showCancelApplBtn"
                @hideCancelApplBtn="hideCancelApplBtn"
                @showFileView="showFileView"
              />
              <!-- 휴/복직(복직신청) -->
              <lea-abs-rch-viewer-data
                v-if="appInfoParam.applCd === '155'"
                :appInfoParam="appInfoParam"
                @showCancelApplBtn="showCancelApplBtn"
                @hideCancelApplBtn="hideCancelApplBtn"
                @showFileView="showFileView"
              />
              <!-- 휴/복직(육아휴직 연장신청) -->
              <lea-abs-par-leave-viewer-data
                v-if="appInfoParam.applCd === '160'"
                :appInfoParam="appInfoParam"
                @showCancelApplBtn="showCancelApplBtn"
                @hideCancelApplBtn="hideCancelApplBtn"
                @showFileView="showFileView"
              />
              <!-- 휴/복직(육아휴직 추가신청) -->
              <lea-abs-par-leave-add-viewer-data
                v-if="appInfoParam.applCd === '152'"
                :appInfoParam="appInfoParam"
                @showCancelApplBtn="showCancelApplBtn"
                @hideCancelApplBtn="hideCancelApplBtn"
                @showFileView="showFileView"
              />
              <!-- 휴일근무사전대체신청 -->
              <hol-replace-viewer-data
                v-if="appInfoParam.applCd === '310'"
                :appInfoParam="appInfoParam"
                @showCancelApplBtn="showCancelApplBtn"
                @hideCancelApplBtn="hideCancelApplBtn"
                @showFileView="showFileView"
              />
              <!-- 휴일근무사전대체취소신청 -->
              <hol-replace-cancel-viewer-data
                v-if="appInfoParam.applCd === '311'"
                :appInfoParam="appInfoParam"
                @showCancelApplBtn="showCancelApplBtn"
                @hideCancelApplBtn="hideCancelApplBtn"
                @showFileView="showFileView"
              />
              <!-- 재직증명신청 -->
              <re-cert-tenure-viewer-data
                v-if="
                  appInfoParam.applCd === '11' || appInfoParam.applCd === '12'
                "
                :appInfoParam="appInfoParam"
                @showCancelApplBtn="showCancelApplBtn"
                @hideCancelApplBtn="hideCancelApplBtn"
                @showFileView="showFileView"
              />
              <!-- 원천징수 -->
              <re-cert-tax-viewer-data
                v-if="
                  appInfoParam.applCd === '16' || appInfoParam.applCd === '19'
                "
                :appInfoParam="appInfoParam"
                @showCancelApplBtn="showCancelApplBtn"
                @hideCancelApplBtn="hideCancelApplBtn"
                @showFileView="showFileView"
              />
              <!-- 휴직증명 -->
              <re-cert-leave-viewer-data
                v-if="appInfoParam.applCd === '21'"
                :appInfoParam="appInfoParam"
                @showCancelApplBtn="showCancelApplBtn"
                @hideCancelApplBtn="hideCancelApplBtn"
                @showFileView="showFileView"
              />
              <!-- 휴직증명 갑근세 -->
              <re-cert-gab-tax-viewer-data
                v-if="appInfoParam.applCd === '18'"
                :appInfoParam="appInfoParam"
                @showCancelApplBtn="showCancelApplBtn"
                @hideCancelApplBtn="hideCancelApplBtn"
                @showFileView="showFileView"
              />
              <!-- 시차출퇴근 -->
              <work-schedule-time-viewer-data
                v-if="appInfoParam.applCd === '304'"
                :appInfoParam="appInfoParam"
                @showCancelApplBtn="showCancelApplBtn"
                @hideCancelApplBtn="hideCancelApplBtn"
                @showFileView="showFileView"
              />
              <!-- 근태/휴가 신청 -->
              <vacations-viewer-data
                v-if="appInfoParam.applCd === '22'"
                :appInfoParam="appInfoParam"
                @showCancelApplBtn="showCancelApplBtn"
                @hideCancelApplBtn="hideCancelApplBtn"
                ref="vacations"
                @showFileView="showFileView"
              />
              <!-- 근태/휴가 취소 신청 -->
              <vacations-cancel-viewer-data
                v-if="appInfoParam.applCd === '23'"
                :appInfoParam="appInfoParam"
                @showCancelApplBtn="showCancelApplBtn"
                @hideCancelApplBtn="hideCancelApplBtn"
                @showFileView="showFileView"

              />
              <!-- 연장근무신청 
              <ot-work-viewer-data
                v-if="appInfoParam.applCd === '110'"
                :appInfoParam="appInfoParam"
              />
              -->
              <!-- 근무스케줄신청 
              <schedule-viewer-data
                v-if="appInfoParam.applCd === '301'"
                :appInfoParam="appInfoParam"
              />
              -->
              <!-- 출퇴근변경신청 
              <attend-viewer-data
                v-if="appInfoParam.applCd === '30'"
                :appInfoParam="appInfoParam"
              />
              -->
            </v-list>
          </v-card>

          <!-- 신청서 그외 정보 -->
          <v-expansion-panels
            v-show="!GET_APP_LOADING_STATUS"
            v-model="panelArray"
            multiple
          >
            <appl-panel>
              <span slot="title">결재자</span>
              <appl-line slot="component" />
            </appl-panel>
            <appl-panel v-show="fileViewShow">
              <span slot="title">첨부파일</span>
              <!-- <attach-file slot="component" /> -->
              <bgf-attach-file-view slot="component" />
            </appl-panel>
            <!--  <appl-panel>
              <span slot="title">참조자</span>
              <refer-line slot="component" />
            </appl-panel>
            -->
            <appl-panel>
              <span slot="title">담당자</span>
              <mgr-line slot="component" />
            </appl-panel>
          </v-expansion-panels>

          <!-- 신청서 뷰어 스켈레톤 로더 -->
          <viewer-skeleton-loader v-show="GET_APP_LOADING_STATUS" />
        </v-col>
      </v-row>
    </v-container>

    <!-- 반려 / 결재버튼 -->
    <v-bottom-navigation
      fixed
      scroll-target="#scroll-threshold-example"
      scroll-threshold="500"
      height="96"
      v-if="isApprDocViewer"
    >
      <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
        <v-col cols="6" class="py-0 pl-0 pr-2">
          <v-btn
            block
            elevation="0"
            class="btn-fixed btn-red"
            @click="openRejectReasonModal()"
          >
            <span class="white--text">반려</span>
          </v-btn>
        </v-col>
        <v-col cols="6" class="py-0 pl-2 pr-0">
          <v-btn
            block
            elevation="0"
            class="btn-fixed btn-blue"
            @click="applConfirm()"
          >
            <span class="white--text">결재</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-bottom-navigation>

    <!-- 휴일사전대체 취소신청 버튼 -->
    <viewer-bottom-btn
      v-if="this.appInfoParam.holReplaceCancelView"
      :btnName="'취소 신청하기'"
      @clickBtn="holReplaceCancel()"
    />


     <!-- 휴가 취소신청 버튼 -->
     <viewer-bottom-btn
      v-if="this.appInfoParam.cancelView"
      :btnName="'취소 신청하기'"
      @clickBtn="vacationCancel()"
    />

    <!-- 취소신청 버튼 -->
    <viewer-bottom-btn
      v-if="cancelBtnShow && GET_APPL_MENU_USE_YN"
      :btnName="'취소 신청하기'"
      @clickBtn="applCancel()"
    />

    <!-- 회수하기 버튼 -->
    <viewer-bottom-btn
      v-if="isApplInProgress && !this.appInfoParam.cancelView"
      :btnName="'회수하기'"
      @clickBtn="applWithdraw()"
    />

    <!-- 회수하기 버튼 -->
    <viewer-bottom-btn
      v-if="(this.appInfoParam.applCd === '152' || this.appInfoParam.applCd === '160') && (this.appInfoParam.applStatusCd === '23' || this.appInfoParam.applStatusCd === '33') "
      :btnName="'삭제하기'"
      @clickBtn="applDelete()"
    />

    <!-- 반려 사유 모달 -->
    <reject-reason-dialog @reject="applReject" />
  </v-dialog>
</template>
<script>
import ApplMenuIcon from '@/components/application/form/ApplMenuIcon.vue';
// import VacationViewerData from '@/components/application/viewer/VacationViewerData.vue';
import VaccinationViewerData from '@/components/application/viewer/VaccinationViewerData.vue';
import EdusAppViewerData from '@/components/application/viewer/EdusAppViewerData.vue';
import LeaAbsParFamViewerData from '@/components/application/viewer/LeaAbsParFamViewerData';
import LeaAbsEtcViewerData from '@/components/application/viewer/LeaAbsEtcViewerData';
import LeaAbsRchViewerData from '@/components/application/viewer/LeaAbsRchViewerData';
import LeaAbsParLeaveViewerData from '@/components/application/viewer/LeaAbsParLeaveViewerData';
import LeaAbsParLeaveAddViewerData from '@/components/application/viewer/LeaAbsParLeaveAddViewerData';
import HolReplaceViewerData from '@/components/application/viewer/HolReplaceViewerData.vue';
import HolReplaceCancelViewerData from '@/components/application/viewer/HolReplaceCancelViewerData.vue';
import ReCertTenureViewerData from '@/components/application/viewer/ReCertTenureViewerData.vue';
import ReCertTaxViewerData from '@/components/application/viewer/ReCertTaxViewerData.vue';
import ReCertLeaveViewerData from '@/components/application/viewer/ReCertLeaveViewerData.vue';
import ReCertGabTaxViewerData from '@/components/application/viewer/ReCertGabTaxViewerData.vue';
import WorkScheduleTimeViewerData from '@/components/application/viewer/WorkScheduleTimeViewerData.vue';
import VacationsViewerData from '@/components/application/viewer/VacationsViewerData.vue';
import VacationsCancelViewerData from '@/components/application/viewer/VacationsCancelViewerData.vue';

// import OtWorkViewerData from '@/components/application/viewer/OtWorkViewerData.vue';
// import ScheduleViewerData from '@/components/application/viewer/ScheduleViewerData.vue';
// import AttendViewerData from '@/components/application/viewer/AttendViewerData.vue';
//import AttachFile from '@/components/application/form/AttachFile.vue';
import ApplLine from '@/components/application/form/ApplLine.vue';
//import ReferLine from '@/components/application/form/ReferLine.vue';
import ApplPanel from '@/components/application/form/ApplPanel.vue';
import PopupHeader from '@/components/common/PopupHeader.vue'; // dialog Header component
import ViewerSkeletonLoader from '@/components/application/viewer/ViewerSkeletonLoader.vue';
import MgrLine from '@/components/application/form/MgrLine.vue';

import ViewerBottomBtn from '@/components/application/buttons/ViewerBottomBtn.vue';
import RejectReasonDialog from '@/components/application/dialog/RejectReasonDialog.vue';

import { postApplCancel, postApplConfirm, postApplReject } from '@/api/ela';
import { deleteApplication } from '@/api/application';

import { mapGetters, mapMutations } from 'vuex';
import viewerMixin from '@/mixins/viewerMixin.js';
import dialogMixin from '@/mixins/dialogMixin.js';
import routerNames from '@/const/routerConstants';
import BgfAttachFileView from '@/components/application/form/BgfAttachFileView.vue';
import { getFileSeq } from '@/api/approvalCommon';

export default {
  mixins: [viewerMixin, dialogMixin],

  data: () => ({
    appViewData: [],
    modalName: 'application_viewer',
    cancelBtnShow: false,
    // 취소신청용
    alterVacationInfo: {},
    fileSeq: 0,
    fileViewShow: true,
  }),

  computed: {
    ...mapGetters(['GET_USER_DATA', 'GET_FILE_SEQ']),
    ...mapGetters('CODE', ['GET_GNT_CD_OBJ']),
    ...mapGetters('DIALOG', ['GET_DIALOG_PARAM']),
    ...mapGetters('MENU', ['GET_APPL_MENU_USE_YN']),
    ...mapGetters('ELA', [
      'GET_ELA_APPL_PARAM',
      'GET_SEARCH_APPL_CD',
      'GET_SEARCH_APPL_SEQ',
      'GET_FILE_LIST',
      //'GET_REFER_USER_LIST',
      'GET_MGR_USER_LIST',
    ]),

    panelArray() {
      let panel = [0];

      if (this.GET_FILE_SEQ !== 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.fileSeq = this.GET_FILE_SEQ;
      }

      if (this.fileSeq > 0) panel.push(1);
      // if (this.GET_REFER_USER_LIST.length > 0) panel.push(2);
      if (this.GET_MGR_USER_LIST.length > 0) panel.push(2);
      return panel;
    },
    appInfoParam() {
      return this.GET_DIALOG_PARAM;
    },
    // 결재처리중인지
    isApplInProgress() {
      return (
        (!this.isApprDocViewer && this.appInfoParam.applStatusCd === '21') ||
        false
      );
    },
    /* 버튼유무에 따른 스크롤 높이 제어 */
    // scrollViewStyle() {
    //   if (
    //     this.isApprDocViewer ||
    //     (this.cancelBtnShow && this.GET_APPL_MENU_USE_YN) ||
    //     this.isApplInProgress
    //   ) {
    //     return `max-height: ${
    //       window.innerHeight - this.vt_header_title_button
    //     }px`;
    //   } else {
    //     return `max-height: ${window.innerHeight - this.vt_header_title}px`;
    //   }
    // },
  },

   // watch: {
   //   appInfoParam() {
   //     this.SET_FILE_LIST([]);
   //     // 신청서 기본정보 조회
   //     this.fetchAppInfo();
   //     // 취소신청 버튼 일단 숨김 처리
   //     this.hideCancelApplBtn();
   //   },
   // },

  created() {
    // console.dir('this.appInfoParam : ' + JSON.stringify(this.appInfoParam));
    this.SET_FILE_LIST([]);
    this.fetchAppInfo();
    this.hideCancelApplBtn();
  },

  methods: {
    ...mapMutations('CODE', ['SET_GNT_CODE_TMP', 'SET_GNT_GUBUN_TMP']),
    ...mapMutations('ELA', [
      'SET_FILE_LIST',
      'SET_APP_MAP_DATA',
      'SET_GNT_CD',
      'SET_HALF_YN',
      'SET_ALTER_VACATION',
      'SET_APP_MENU',
      'SET_CLOSE_DAY',
      'SET_CLOSE_DAY_DATA',
      'SET_VACATION_STATE',
      'SET_SEARCH_BF_APPL_SEQ',
    ]),
    ...mapMutations('SPINNER', ['ON_COMMON_SPINNER', 'OFF_COMMON_SPINNER']),

    async vacationCancel() {
      /*
      this.$router.push({
        name: routerNames.HolReplaceCancelSubView,
        params: this.appInfoParam,
      });
      */

      this.$store.commit('SET_APPL_SEQ', this.appInfoParam.applSeq);

      const applParam = {
        applCd: '23',
      };

      await this.$store.dispatch('ELA/FETCH_MENU_ACTION', applParam);

      this.$store.commit('DIALOG/TOGGLE_MODAL', 'application_viewer');
      //this.$store.commit('DIALOG/TOGGLE_MODAL', modalNm);
      this.$router.push({
        name: routerNames.VacationCancelView,
        params: this.appInfoParam,
      });
    },

    async holReplaceCancel() {
      /*
      this.$router.push({
        name: routerNames.HolReplaceCancelSubView,
        params: this.appInfoParam,
      });
      */

      this.$store.commit('SET_APPL_SEQ', this.appInfoParam.applSeq);
      /*
      const applParam = {
        applCd: '311',
      };

      await this.$store.dispatch('ELA/FETCH_MENU_ACTION', applParam);
      */
      this.$store.commit('DIALOG/TOGGLE_MODAL', 'application_viewer');
      //this.$store.commit('DIALOG/TOGGLE_MODAL', modalNm);
      this.$router.push({
        name: routerNames.HolReplaceCancelSubView,
        params: this.appInfoParam,
      });
    },

    /* 신청 상세 기본 정보 조회 */
    async fetchAppInfo() {
      if(Object.keys(this.appInfoParam).length === 0) return;
      const initParams = {
        searchApplCd: this.appInfoParam.applCd,
        adminYn: 'N',
        authPg: 'R',
        searchApplSeq: this.appInfoParam.applSeq,
        searchApplSabun: this.appInfoParam.applSabun,
        searchApplInSabun: this.appInfoParam.applInSabun,
        searchApplStatusCd: this.isApplConfirmViewer
          ? '21'
          : this.appInfoParam.applStatusCd,
      };

      try {
        await this.$store.dispatch('ELA/FETCH_ELA_APPL_INFO', initParams);
        //await this.$store.dispatch('ELA/FETCH_FILE_LIST'); 추후에 bgf용으로 변경
      } catch (error) {
        alert(error);
      }
    },

    /* 취소신청시 */
    async applCancel() {
      // 취소신청 코드
      let searchApplCd = '';
      if (this.appInfoParam.applCd === '22') searchApplCd = '23';
      if (this.appInfoParam.applCd === '42') searchApplCd = '43';
      if (searchApplCd === '') return false;

      const initParams = {
        searchApplCd,
        adminYn: 'N',
        authPg: 'A',
        etc01: this.appInfoParam.applSeq,
        searchApplSeq: '',
        searchApplSabun: this.appInfoParam.applSabun,
        searchApplInSabun: this.appInfoParam.applInSabun,
      };

      try {
        // 취소 신청 기본정보 조회
        await this.$store.dispatch('ELA/FETCH_ELA_APPL_INFO', initParams);

        // 추가 옵션 화면 조회시 필요 데이터 세팅
        this.SET_APP_MENU({ applCd: searchApplCd });
        this.SET_SEARCH_BF_APPL_SEQ(this.appInfoParam.applSeq);
        this.SET_VACATION_STATE(this.GET_APP_MAP_DATA);
        this.SET_GNT_CD(this.GET_GNT_CD_OBJ);
        this.SET_HALF_YN();
        this.SET_CLOSE_DAY_DATA(this.GET_APP_MAP_DATA.closeDay);
        this.toggleModal();
        // 추가옵션 화면으로 바로 이동
        this.$router.push(routerNames.ExtraOptions);
      } catch (error) {
        alert(error);
      }
    },

    /* 회수 + 삭제 */
    async applWithdraw() {
      if (confirm('신청서를 회수하시겠습니까?\n회수하기를 하면 신청서는 삭제 됩니다')) {
        const applSeq = this.appInfoParam.applSeq.toString();
        const applCd = this.appInfoParam.applCd;

        // eslint-disable-next-line no-unreachable
        try {
          // 회수처리
          const response = await postApplCancel({
            searchApplSeq: applSeq,
          });
          //const resultCnt = response.data.data.cnt;
          const resultCnt = response.data.data;

          // 회수 성공시 삭제처리
          if (resultCnt >= 1) {
            const deleteRows = [];

            deleteRows.push({ applSeq });

            let deleteResponse = await deleteApplication(applCd, {
              deleteRows,
            });
            const resultData = deleteResponse.data.data;

            //const resultData = 1;
            if (resultData >= 1) {
              // if (applCd === '7051' || applCd === '7021') {
              //   alert('신청서 회수가 완료되었습니다.');
              //   this.closeModal();
              //   this.$router.go(-1);
              // } else {
              //   this.$store.commit('DIALOG/SET_DIALOG_CALLBACK', true); // 모달 종료 콜백 ON
              //   alert('신청서 회수가 완료되었습니다.');
              //   this.closeModal();
              // }

                this.$store.commit('DIALOG/SET_DIALOG_CALLBACK', true); // 모달 종료 콜백 ON
                alert('신청서 회수가 완료되었습니다.');
                this.closeModal();

            } else {
              alert('신청서 회수가 완료되었습니다.');
            }

            return false;
          }

          alert('회수에 실패했습니다. 잠시 후 다시 시도해주세요.');
        } catch (error) {
          console.log(error);
        }
      }
    },

    /* 육아연장, 추가 삭제 */
    async applDelete() {
      if (confirm('신청서를 삭제하시겠습니까?\n삭제하기를 하면 신청서는 삭제 됩니다')) {
        const applSeq = this.appInfoParam.applSeq.toString();
        const applCd = this.appInfoParam.applCd;

        // eslint-disable-next-line no-unreachable
        try {
          // 회수처리
          const response = await postApplCancel({
            searchApplSeq: applSeq,
          });
          //const resultCnt = response.data.data.cnt;
          const resultCnt = response.data.data;

          // 회수 성공시 삭제처리
          if (resultCnt >= 1) {
            const deleteRows = [];

            deleteRows.push({ applSeq });

            let deleteResponse = await deleteApplication(applCd, {
              deleteRows,
            });
            const resultData = deleteResponse.data.data;

            //const resultData = 1;
            if (resultData >= 1) {
              // if (applCd === '7051' || applCd === '7021') {
              //   alert('신청서 회수가 완료되었습니다.');
              //   this.closeModal();
              //   this.$router.go(-1);
              // } else {
              //   this.$store.commit('DIALOG/SET_DIALOG_CALLBACK', true); // 모달 종료 콜백 ON
              //   alert('신청서 회수가 완료되었습니다.');
              //   this.closeModal();
              // }

                this.$store.commit('DIALOG/SET_DIALOG_CALLBACK', true); // 모달 종료 콜백 ON
                alert('신청서가 삭제가 완료되었습니다.');
                this.closeModal();

            } else {
              alert('신청서 삭제가 완료되었습니다.');
            }

            return false;
          }

          alert('삭제에 실패했습니다. 잠시 후 다시 시도해주세요.');
        } catch (error) {
          console.log(error);
        }
      }
    },

    /* 결재 */
    async applConfirm() {
      if (!confirm('결재하시겠습니까?')) return false;
      this.ON_COMMON_SPINNER(); // 공통 스피너 ON

      try {
        const param = {
          searchApplSabun: this.appInfoParam.applSabun,
          searchApplSeq: this.appInfoParam.applSeq.toString(),
          searchApplCd: this.appInfoParam.applCd,
          agreeSeq: this.appInfoParam.agreeSeq.toString(),
          agreeGubun: this.appInfoParam.agreeGubun,
          agreeUserStatus: '1', //결제
          applStatusCd: this.appInfoParam.applStatusCd,
          applSeq: this.appInfoParam.applSeq,
        };

        const response = await postApplConfirm(param);

        if (response == null || response.data.data.cnt < 0) {
          alert('처리중 오류가 발생했습니다.');
        } else {
          this.$store.commit('DIALOG/SET_DIALOG_CALLBACK', true); // 모달 종료 콜백 ON
          alert('결재 되었습니다.');
          this.closeModal();
        }

        this.OFF_COMMON_SPINNER(); // 공통 스피너 OFF
      } catch (error) {
        console.log(error);
        this.OFF_COMMON_SPINNER(); // 공통 스피너 OFF
      }
    },

    /* 반려사유 입력 모달 오픈 */
    openRejectReasonModal() {
      this.$store.commit('DIALOG/TOGGLE_MODAL', 'reject_reason');
    },

    /* 반려 */
    async applReject(agreeUserMemo) {
      this.ON_COMMON_SPINNER(); // 공통 스피너 ON
      try {
        const param = {
          searchApplSabun: this.appInfoParam.applSabun,
          searchApplSeq: this.appInfoParam.applSeq.toString(),
          searchApplCd: this.appInfoParam.applCd,
          agreeSeq: this.appInfoParam.agreeSeq.toString(),
          agreeGubun: this.appInfoParam.agreeGubun,
          agreeUserMemo: agreeUserMemo,
          agreeUserStatus: '0', // 반려
          applStatusCd: this.appInfoParam.applStatusCd,
          applSeq: this.appInfoParam.applSeq,
        };

        const response = await postApplReject(param);
        if (response == null || response.data.data.cnt < 0) {
          alert('처리중 오류가 발생했습니다.');
        } else {
          this.$store.commit('DIALOG/SET_DIALOG_CALLBACK', true); // 모달 종료 콜백 ON
          alert('반려 되었습니다.');
          this.closeModal();
        }
        this.OFF_COMMON_SPINNER(); // 공통 스피너 OFF
      } catch (error) {
        console.log(error);
        this.OFF_COMMON_SPINNER(); // 공통 스피너 OFF
      }
    },

    /** 취소신청 버튼 제어 */
    showCancelApplBtn() {
      this.cancelBtnShow = true;
    },
    hideCancelApplBtn() {
      this.cancelBtnShow = false;
    },

    showFileView(flag) {
      this.fileViewShow = flag;
    }
  },

  components: {
    // VacationViewerData,
    // OtWorkViewerData,
    // ScheduleViewerData,
    // AttendViewerData,
    //AttachFile,
    ApplLine,
    /* ReferLine,*/
    ApplMenuIcon,
    PopupHeader,
    ApplPanel,
    ViewerBottomBtn,
    RejectReasonDialog,
    ViewerSkeletonLoader,
    MgrLine,
    VaccinationViewerData,
    EdusAppViewerData,
    LeaAbsParFamViewerData,
    LeaAbsEtcViewerData,
    LeaAbsRchViewerData,
    LeaAbsParLeaveViewerData,
    LeaAbsParLeaveAddViewerData,
    BgfAttachFileView,
    HolReplaceViewerData,
    HolReplaceCancelViewerData,
    ReCertTenureViewerData,
    ReCertTaxViewerData,
    ReCertLeaveViewerData,
    ReCertGabTaxViewerData,
    WorkScheduleTimeViewerData,
    VacationsViewerData,
    VacationsCancelViewerData,
  },
};
</script>
<style scoped>
/* application.scss 참고 */

</style>
